import { Component, Input, OnInit } from '@angular/core';
import { ColorsConst, PaymentChannelType, UtilsService } from 'src/app/core';

@Component({
  selector: 'app-payment-channels-type-avatar',
  templateUrl: './payment-channels-type-avatar.component.html',
  styleUrls: ['./payment-channels-type-avatar.component.less'],
})
export class PaymentChannelsTypeAvatarComponent implements OnInit {
  @Input() paymentChannelType: PaymentChannelType;

  PaymentChannelType = PaymentChannelType;
  paymentChannelsLogosUrl: Object;
  ImgBgColor: string;
  ColorsConst = ColorsConst;

  constructor(private utilsService: UtilsService) {}

  ngOnInit(): void {
    this.paymentChannelsLogosUrl =
      this.utilsService.setPaymentChannelsLogosUrl();

    this.setImgBgColor();
  }

  setImgBgColor() {
    switch (this.paymentChannelType) {
      case PaymentChannelType.OXXO_PAY:
        this.ImgBgColor = '#E21C2A';
        break;
      case PaymentChannelType.VESTA_CARD:
        this.ImgBgColor = '#ffffff';
        break;

      default:
        this.ImgBgColor = ColorsConst.primary;
    }
  }
}
